import { render, staticRenderFns } from "./Func49Listagem.vue?vue&type=template&id=535bf509&scoped=true"
import script from "./Func49Listagem.vue?vue&type=script&lang=js"
export * from "./Func49Listagem.vue?vue&type=script&lang=js"
import style0 from "./Func49Listagem.vue?vue&type=style&index=0&id=535bf509&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bf509",
  null
  
)

export default component.exports